import * as React from 'react';
export const MVSvg = React.forwardRef(function MVSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#B1372F',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M3 3h10v6H3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M9.5 4.268a1.75 1.75 0 1 0 0 3.464 2 2 0 1 1 0-3.464Z',
      }),
    ),
  );
});
MVSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MV = {
  category: 'flag',
  colorable: false,
  name: 'MV',
  svg: MVSvg,
};
